/** 학급 일일 출결 — 현재는 결석만 사용 */
export type DailyAttendanceStatus = 'absent';

export interface DailyAttendanceDoc {
  date: string;
  records: Record<string, DailyAttendanceStatus>;
  updatedAt?: Date;
  updatedBy?: string;
}

/** 로컬 날짜 기준 YYYY-MM-DD */
export const getAttendanceDateKey = (date: Date = new Date()): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const parseAttendanceDateKey = (dateKey: string): Date | null => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateKey);
  if (!match) return null;
  const [, y, m, d] = match;
  return new Date(Number(y), Number(m) - 1, Number(d));
};

export const getDailyAttendancePath = (
  schoolId: string,
  classId: string,
  dateKey: string
): string => `schools/${schoolId}/classes/${classId}/dailyAttendance/${dateKey}`;

export const isStudentAbsent = (
  records: Record<string, DailyAttendanceStatus> | undefined,
  studentId: string | null
): boolean => {
  if (!records || !studentId) return false;
  return records[studentId] === 'absent';
};

export const countAbsentStudents = (
  records: Record<string, DailyAttendanceStatus> | undefined
): number => Object.values(records ?? {}).filter((status) => status === 'absent').length;
